import React from 'react'

const loader = () => {
  return (
    <div className="load-bar">
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
    </div>
  )
}

export default loader